import { type RouteObject } from 'react-router'

import { SOURCE_UPLOAD_URL } from 'features/source-upload/paths'
import { lazyComponent } from 'routes/lazy-route'

export const sourceUploadRoutes: RouteObject[] = [
  {
    path: SOURCE_UPLOAD_URL,
    lazy: lazyComponent(
      () => import('features/source-upload/Container'),
      'SourceUpload',
    ),
    handle: { featureKey: SOURCE_UPLOAD_URL },
  },
]
